export default {
  v3OfficialTopUpCenterTitle: 'Centro Oficial de Recarga',
  v3OfficialTopUpCenterKeyword: 'Centro Oficial de Recarga',
  v3OfficialTopUpCenterDescription: 'Centro Oficial de Recarga',
  v3SafeAndFast: 'Seguro, sem riscos, e crédito instantâneo',
  v3Shop: 'Loja',
  v3ShoppingCart: 'Carrinho de Compras',
  v3MembershipCenter: 'Centro de Privilégios (Centro de Membros Premium)',
  v3Login: 'Entrar',
  v3Account: 'Conta',
  v3EnterAccountName: 'Digite o Nome da Conta',
  v3Password: 'Senha',
  v3EnterPassword: 'Digite a Senha',
  v3ForgotPassword: 'Esqueceu a Senha',
  v3EnterUID: 'Digite o UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'Por favor, digite o OTP',
  v3SelectTopUpCharacter: 'Selecione o personagem de recarga',
  v3SelectServer: 'Selecione o Servidor',
  v3Confirm: 'Confirmar',
  v3CharacterNotFound:
    'Se não encontrar o personagem, tente fazer login com o personagem no jogo primeiro, depois entre na página de recarga ou entre em contato com o atendimento ao cliente.',
  v3Logout: 'Sair',
  v3SwitchAccount: 'Trocar Conta',
  v3MyCoupons: 'Meus Cupons',
  v3BenefitsCenter: 'Centro de Privilégios',
  v3TopUpBenefits: 'Benefícios de Recarga',
  v3MoreSettings: 'Mais Configurações',
  v3RememberLoginStatus: 'Lembrar meu status de login',
  v3OrderQuery: 'Verificar Pedidos',
  v3ContactCustomerService: 'Atendimento ao Cliente',
  v3LoginWithApp: 'Entrar pelo App',
  v3ChooseOtherLoginMethod: 'Selecione um método alternativo de login',
  v3ConnectingToGameApp: 'Conectando ao aplicativo do jogo',
  v3EnsureGameInstalled:
    'Certifique-se de que o jogo está instalado neste dispositivo. Se o jogo não responder ou o login falhar, atualize-o para a versão mais recente na loja de aplicativos ou troque de navegador.',
  v3OpenGame: 'Iniciar Jogo',
  v3DownloadGame: 'Baixar Jogo',
  v3UpdateGameIfOpenFails:
    'Se o jogo não iniciar, atualize para a versão mais recente na App Store/Google Play.',
  v3ClickToDownloadLatestVersion:
    'Alternativamente, você pode clicar no botão para baixar a versão mais recente do jogo.',
  v3LoggingIntoOfficialTopUpCenter:
    'Você está entrando no [Centro Oficial de Recarga]',
  v3CurrentAccount: 'Conta atual: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Bem-vindo ao Centro Oficial de Recarga',
  v3OfficialAuthorizedLogin:
    'Login oficialmente autorizado. Sem riscos de segurança.',
  v3TermsOfService: 'Termos de Serviço',
  v3PrivacyPolicy: 'Política de Privacidade',
  v3ThirdPartySocialAccountDescription:
    'Sobre Conta de Mídia Social de Terceiros',
  v3BindSocialAccountInGameFirst:
    'Complete a vinculação da sua conta de mídia social no Centro de Usuário dentro do jogo, depois faça login com a conta de mídia social vinculada.',
  v3FirstTopUp15PercentOff:
    'Aproveite até 15% de DESCONTO na sua primeira recarga',
  v3MoreTopUpRebates: 'Mais recompensas e reembolsos por recarga',
  v3LoginToViewOffers: 'Entre para ver os descontos',
  v3TopUpEnvironmentChecking: 'Verificando ambiente de recarga...',
  v3SafeToUse: 'Seguro e protegido.',
  v3LimitedTimeBenefits: 'Oferta Exclusiva por Tempo Limitado',
  v3EventRules: 'Regras do Evento',
  v3MoreEvents: 'Mais Eventos',
  v3Claim: 'Resgatar',
  v3Completed: 'Concluído',
  v3GoTo: 'Ir',
  v3ViewDetails: 'Ver Detalhes',
  v3RecommendedProducts: 'Itens Recom.',
  v3SearchProductName: 'Buscar pelo nome do item',
  v3AllCategories: 'Tudo',
  v3PopularSort: 'Populares',
  v3PriceAscending: 'Preço ↑',
  v3PriceDescending: 'Preço ↓',
  v3DiamondBonus10Percent: 'Diamante +10%',
  v3YuanbaoBonus10Percent: 'Lingote +10%',
  v3ExtraBonus10Percent: 'Bônus: 10%',
  v3FirstTopUpDouble: '1ª Recarga em Dobro',
  v3FirstExtraBonus: 'Bônus de Primeira Vez',
  v3ProductDetails: 'Detalhes do Produto',
  v3AddToCart: 'Adicionar ao Carrinho',
  v3AddedToCart: 'Adicionado ao Carrinho',
  v3BuyNow: 'Comprar Agora',
  v3NoItemsInCart: 'Nenhum item no seu carrinho ainda',
  v3SelectedItemsN: 'Itens selecionados: (${n})',
  v3RemoveFromCart: 'Remover do carrinho?',
  v3Yes: 'Sim',
  v3No: 'Não',
  v3LimitOnePerPurchase: 'Apenas um deste item pode ser comprado por vez',
  v3ItemPrice: 'Preço do Item',
  v3Tax: 'Imposto',
  v3ExtraGift: 'Bônus',
  v3Total: 'Total',
  v3ProceedToPayment: 'Pagar',
  v3SelectCoupon: 'Selecionar Cupom',
  v3UnavailableCoupons: 'Cupons Não Usáveis',
  v3OneCouponPerOrder: 'Um cupom por pedido',
  v3DiscountCoupon: 'Cupom de Desconto',
  v3ThresholdCoupon: 'Cupom de Dedução',
  v3MinSpendCoupon: 'Usável quando o valor total for superior a xx USD',
  v3MaxDiscountCoupon: 'Desconto de até xxxx USD',
  v3LimitedChannel: 'Limitado a canais específicos',
  v3AllChannels: 'Disponível para todos os canais',
  v3SpecificProducts: 'Apenas para itens específicos',
  v3AllProducts: 'Para todos os itens',
  v3NotYetTimeToUse: 'Ainda não utilizável',
  v3Expired: 'Expirado',
  v3Used: 'Usado',
  v3ValidityPeriod: 'Validade:',
  v3ConfirmUse: 'Confirmar',
  v3ChangeProduct: 'Alterar Item',
  v3ConfirmPaymentOrder: 'Confirmar Pedido',
  v3StoredValueRole: 'Personagem de Recarga',
  v3TotalNProducts: 'Total de itens: ${n}',
  v3SelectPaymentMethod: 'Selecionar Método de Pagamento',
  v3PayNow: 'Pagar Agora',
  v3MorePaymentMethods: 'Mais Métodos de Pagamento',
  v3NoAvailablePaymentMethodContactSupport:
    'Não encontra nenhum método de pagamento disponível? Contate o Atendimento ao Cliente.',
  v3AvailableCoupons: 'Cupons Usáveis',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Escolha Anterior',
  v3RecommendedUsage: 'Recomendado',
  v3PopularChoice: 'Escolha Popular',
  v3PaymentSuccess: 'Pagamento Concluído',
  v3PaymentFailure: 'Falha no pagamento',
  v3TopUpFailureMessage:
    'Desculpe, a recarga falhou. Tente reenviar o pedido ou entre em contato com o atendimento ao cliente.',
  v3Game: 'Jogo',
  v3UID: 'UID',
  v3OrderNumber: 'Nº do Pedido',
  v3ProductContent: 'Detalhes do Item',
  v3ViewProductDetails: 'Ver Detalhes do Item',
  v3PaymentMethod: 'Método de Pagamento',
  v3Complete: 'Concluir',
  v3TopUpAgain: 'Recarregar Novamente',
  v3FriendlyReminderSaveOrderInfo:
    'Aviso: Salve suas informações de pedido por captura de tela para agilizar o processamento.',
  v3RechargeAgain: 'Recarregar Novamente',
  v3TransactionInProgress: 'Processando transação',
  v3CompletePaymentInChannel:
    'Por favor, prossiga para o canal de pagamento para completar o pagamento.',
  v3RestAssuredFastDeliveryAfterPayment:
    'O item será enviado assim que o resultado do pagamento for recebido.',
  v3SaveOrderInfoForProgress:
    'Você pode tirar uma captura de tela das informações do pedido para acompanhar o andamento da transação.',
  v3PaymentCompleted: 'Pagamento concluído',
  v3AddToHomeScreen: 'Adicionar à Tela Inicial',
  v3AddShortcutForBonus:
    'Adicione um atalho para receber recompensas adicionais',
  v3ShareSuccess: 'Compartilhado',
  v3ShareFailure: 'Falha ao compartilhar',
  v3RewardClaimed: 'Recompensa Resgatada',
  v3RewardClaimFailed: 'Falha ao resgatar a recompensa',
  v3EventNotStarted: 'O evento ainda não começou',
  v3EventEnded: 'O evento já terminou',
  v3ClickSelectCoupon: 'Clique para selecionar cupão',
  v3CouponsRecommendedUsed: 'Cupão recomendado utilizado',
  v3CouponsSelected: 'Cupão selecionado',
  v3NoCouponsAvaliable: 'Sem cupões disponíveis',
  v3SupplementStatus: 'Estado',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Banido',
  v3SupplementPendingPayment: 'Pagamento Pendente',
  v3SupplementSwitchCharacter: 'Trocar Personagem',
  v3SupplementAccountInfoInvalid: 'Informações da Conta Inválidas',
  v3SupplementContactGSForTopUpLink:
    'Por favor, contacte o GS para obter o link de recarga',
  v3SupplementTopUpCompleted: 'Recarga Concluída:',
  v3SupplementTotalRefundOrders: 'Total de {} pedidos de reembolso',
  v3SupplementPendingSupplementAmount: 'Montante de Pagamento Pendente:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Conta/Personagem normal, não é necessário pagamento',
  v3SupplementEnjoyYourGame: 'Divirta-se no jogo!!',
  v3SupplementOrderInformation: 'Informação do Pedido',
  v3SupplementPendingPaymentAmount: 'Montante Pendente de Pagamento:',
  v3LookUpCouponRule: 'Verifique as regras de distribuição de cupons',
  v3SwitchOldVersion: 'Mudar para a antiga Plataforma de pagamento',
  v3FirstTopUpGiveaway: 'Bônus de 1ª Recarga',
  v3SecureConnection: 'Estabelecendo conexão segura',
  v3RequestTimeOut:
    'Tempo limite de carregamento esgotado, tente novamente mais tarde.',
  v3ConfirmLeave: 'Sair?',
  v3NoSubmitOrder:
    'Seu carrinho ainda não foi finalizado, você pode perder os itens desejados se sair.',
  v3ContinueSubmit: 'Continuar',
  v3LeaveSubmit: 'Sair',
  v3RecentBug: 'Compras recentes'
};
